module.exports = __webpack_public_path__ + "img/15.5bac50d7.jpg";